import React from "react";

const HeroBanner = () => {
  return (
    <section className="bg-gradient-to-r from-primary to-primary-dark text-white py-24 px-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-12">
        {/* Text Section */}
        <div className="md:w-1/2 text-center md:text-left space-y-6">
          <h1 className="text-4xl md:text-6xl font-bold leading-tight">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-accent to-accent-light">
              Empowering
            </span>{" "}
            Your Network Infrastructure
          </h1>
          <p className="text-lg md:text-xl text-white/90 max-w-lg">
            We design, deploy, and support secure and scalable networking solutions for businesses of all sizes.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
            <a
              href="/contact"
              className="inline-block px-8 py-4 bg-accent hover:bg-accent-dark text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              Request a Consultation
            </a>
            <a
              href="/services"
              className="inline-block px-8 py-4 bg-transparent border-2 border-white/20 hover:border-white/40 text-white font-semibold rounded-lg hover:bg-white/10 transition-all duration-300"
            >
              Explore Solutions
            </a>
          </div>
          <div className="pt-4 flex items-center justify-center md:justify-start gap-4 text-sm text-white/80">
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
              <span>24/7 Support</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 bg-blue-400 rounded-full animate-pulse"></span>
              <span>Enterprise-grade Security</span>
            </div>
          </div>
        </div>

        {/* Image / Illustration */}
        <div className="md:w-1/2 relative">
          <img
            src="/assets/images/hero-networking.svg"
            alt="Networking Solutions Illustration"
            className="w-full max-w-lg mx-auto hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute -z-10 w-full h-full bg-radial-gradient from-accent/20 to-transparent top-0 left-0"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
